const FETCH_CREDITS = 'core/credits/FETCH_CREDITS';
const FETCH_CREDITS_COMPLETED = 'core/credits/FETCH_CREDITS_COMPLETED';
const FETCH_CREDITS_FAILED = 'core/credits/FETCH_CREDITS_FAILED';
const INVALIDATE_CREDITS = 'core/credits/INVALIDATE_CREDITS';
const SELECT_CREDIT = 'core/credits/SELECT_CREDIT';
const PUBLICATION_PLANS = 'core/credits/PUBLICATION_PLANS';
const PUBLICATION_PLANS_COMPLETED = 'core/credits/PUBLICATION_PLANS_COMPLETED';
const PUBLICATION_PLANS_FAILED = 'core/credits/PUBLICATION_PLANS_FAILED';

export {
  PUBLICATION_PLANS,
  PUBLICATION_PLANS_COMPLETED,
  PUBLICATION_PLANS_FAILED,
  FETCH_CREDITS,
  FETCH_CREDITS_COMPLETED,
  FETCH_CREDITS_FAILED,
  INVALIDATE_CREDITS,
  SELECT_CREDIT
};
